// Canonical frequency codes used by backend schema
// W = Weekly, F = Fortnightly, M = Monthly, Q = Quarterly, Y = Yearly
export type FrequencyCode = 'W' | 'F' | 'M' | 'Q' | 'Y';

export const FREQUENCY_CODES: FrequencyCode[] = ['W','F','M','Q','Y'];

// Human labels mapped to codes (can be used for dropdowns if needed)
export const FREQUENCY_LABELS: Record<FrequencyCode, string> = {
  W: 'Weekly',
  F: 'Fortnightly',
  M: 'Monthly',
  Q: 'Quarterly',
  Y: 'Yearly'
};

type LegacyFrequencyKey = 'WEEK' | 'WEEKLY' | 'FORTNIGHT' | 'FORTNIGHTLY' | 'MONTH' | 'MONTHLY' | 'QUARTER' | 'QUARTERLY' | 'YEAR' | 'YEARLY';

// Accepts legacy verbose values or already compact codes; returns compact code.
export function toFrequencyCode(value: string | null | undefined): FrequencyCode {
  if(!value) return 'F';
  const v = value.toString().trim().toUpperCase();
  if((FREQUENCY_CODES as string[]).includes(v)) return v as FrequencyCode;
  const map: Record<LegacyFrequencyKey, FrequencyCode> = { WEEK:'W', WEEKLY:'W', FORTNIGHT:'F', FORTNIGHTLY:'F', MONTH:'M', MONTHLY:'M', QUARTER:'Q', QUARTERLY:'Q', YEAR:'Y', YEARLY:'Y' };
  return map[v as LegacyFrequencyKey] || 'F';
}

// Reverse lookup for presenting code back to user
export function frequencyCodeToLabel(code: string): string {
  return FREQUENCY_LABELS[code as FrequencyCode] || 'Fortnightly';
}

type NormalizedFrequency = 'WEEK' | 'FORTNIGHT' | 'MONTH' | 'QUARTER' | 'YEAR';

// Maps any frequency input to normalized long-form: WEEK, FORTNIGHT, MONTH, QUARTER, YEAR
const CODE_TO_LONG: Record<FrequencyCode, NormalizedFrequency> = { W: 'WEEK', F: 'FORTNIGHT', M: 'MONTH', Q: 'QUARTER', Y: 'YEAR' };

export function toNormalizedFrequency(value: string | null | undefined): NormalizedFrequency {
  return CODE_TO_LONG[toFrequencyCode(value)] || 'FORTNIGHT';
}
